import { featuredComics } from "@/mocks/homeData";
import ComicCard from "./ComicCard";

export default function Featured() {
  return (
    <section id="featured" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-sm font-bold text-primary-600">
              本周人气 · 编辑部严选
            </span>
            <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">
              热门脑洞短篇推荐
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-700 md:text-base">
              大家正在看的创意短篇都在这里，节奏紧凑、反转频出，每篇都是通勤路上的最佳伴侣。
            </p>
          </div>
          <a
            href="#latest"
            onClick={(e) => {
              e.preventDefault();
              document
                .querySelector("#latest")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-100"
          >
            更多新作
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featuredComics.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </section>
  );
}